import { adminSupportPromptTemplatesApi as api } from '../../../api/admin/SupportPromptTemplates'

const state = {
    objects: {},
    objectList: []
}

const getters = {
    all: state => state.objectList.map(id => state.objects[id]),
    getById: (state) => (id) => {
        return state.objects[id]
    },
}

const actions = {
    loadAll ({commit}) {
        return new Promise((resolve) => {
            api.getAll()
                .then(({data}) => {
                    commit('set', {
                        objects: data.data
                    })
                    resolve()
                })
        })
    },
    add ({commit}, payload) {
        commit('add', payload)
    },
    update ({commit}, payload) {
        commit('update', payload)
    },
    remove ({commit}, payload) {
        commit('remove', payload)
    },
}

const mutations = {
    set (state, payload) {
        state.objects = payload.objects.reduce((obj, object) => {
            obj[object.id] = object
            return obj
        }, {})
        state.objectList = payload.objects.map(object => object.id)
    },
    add (state, payload) {
        state.objects[payload.object.id] = payload.object
        state.objectList.push(payload.object.id)
    },
    update (state, payload) {
        state.objects[payload.object.id] = payload.object
    },
    remove (state, payload) {
        delete state.objects[payload.id]
        state.objectList = state.objectList.filter(id => id !== payload.id)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
